// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : EXCEL PART REMOVED
// MODFIED DATA : 27-09-2025

import ReceiptsPaymentsActionTypes from './ReceiptsPayments.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	// RECEIPTS AND PAYMENTS LIST RESPONSE
	getReceiptsPaymentsListResponse: null,
	getReceiptsPaymentsListArr: [],
};

const receiptsPaymentsReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START GET RECEIPTS AND PAYMENTS DETAILS  ******************** */
		case ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_SUCCESS:
			return {
				...state,
				getReceiptsPaymentsListResponse: action.payload,
				getReceiptsPaymentsListArr: docodeHexResponse(
					action.payload,
					'GetReceiptsPaymentsKey',
				),
			};

		case ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_FAILURE:
			return {
				...state,
				getReceiptsPaymentsListResponse: action.payload,
				getReceiptsPaymentsListArr: [],
			};

		case ReceiptsPaymentsActionTypes.GET_RECEIPTS_PAYMENTS_LIST_RESPONSE_CHANGED:
			return {
				...state,
				getReceiptsPaymentsListResponse: null,
			};

		/** *********************  END GET RECEIPTS AND PAYMENTS DETAILS  ******************** */

		default:
			return state;
	}
};

export default receiptsPaymentsReducer;
